// extracted by mini-css-extract-plugin
module.exports = {"Text":"GoogleSearcher_Text__2JGn0","AppnameContainer":"GoogleSearcher_AppnameContainer__2fW-4","Form":"GoogleSearcher_Form__hYQzj"};